<template>
  <div>

    <Card>
      <Row :gutter="24">
          <Col span="3">
            <Button type="primary" @click="add">新增</Button>
          </Col>
          <Col span="3">
              <Input v-model="params.director_name" @on-change="getSoftwareAssetsDistribute">
                  <span slot="prepend">责任人</span>
              </Input>
          </Col>
          <Col span="3">
              <Button type="text" icon="md-refresh-circle" @click="getSoftwareAssetsDistribute"></Button>
          </Col>
      </Row>
    </Card>

    <Table highlight-row ref="currentRowTable" :columns="distributeColumns" :data="assetList"></Table>
    <Page :total="count" :current="params.page" show-sizer show-total :page-size="params.size" @on-change="currentHandle" @on-page-size-change="pageSizeHandle"></Page>

    <Drawer :title="formItem.id ? '编辑' : '新增'" v-model="drawerChange" width="672" :mask-closable="false" @on-close="drawerChange=false">
      <i-form ref="formItem" :model="formItem" :label-width="80" :rules="ruleValidate">

        <form-item label="部门" prop="department">
          <!-- <i-input v-model="formItem.department" placeholder=""></i-input> -->
          <Treeselect :async="false" v-model="formItem.department" valueConsistsOf='LEAF_PRIORITY' @input="eventInputDeparement" valueFormat="object" clearable
          :multiple="false" :options="options" :load-options="loadOptions" :searchable="true" :disableBranchNodes="true" placeholder="组织架构选择">
          </Treeselect>
        </form-item>

        <form-item label="授权软件" prop="software_assets_authorize">
          <Transfer
            :data="software_assets_authorize"
            :target-keys="formItem.software_assets_authorize"
            filterable
            :filter-method="filterMethod"
            @on-change="handleChangeAuthorize">
          </Transfer>
        </form-item>

        <form-item label="数量" prop="count">
          <i-input v-model="formItem.count" placeholder=""></i-input>
        </form-item>

        <form-item label="责任人" prop="director_name">
          <Treeselect :async="true" v-model="formItem.director_name" valueConsistsOf='LEAF_PRIORITY' valueFormat="object" clearable @input="eventInputUser"
                      :multiple="false" :load-options="loadOptionsAsync" :searchable="true" :disableBranchNodes="true" placeholder="人员模糊查找">
          </Treeselect>
        </form-item>

        <form-item label="备注" prop="remark">
          <i-input v-model="formItem.remark" placeholder=""></i-input>
        </form-item>

        <form-item>
          <i-button type="primary" @click="handleSubmit('formItem')">提交</i-button>
          <i-button style="margin-left: 8px" @click="drawerChange=false">取消</i-button>
        </form-item>

      </i-form>

      <spin fix v-if="changeLoadingShow">
        <Icon type="load-c" size=18 class="demo-spin-icon-load"></Icon>
        <div>请求中....</div>
      </spin>

    </Drawer>

    <Modal
        v-model="logModal"
        title="日志"
        :mask-closable="false"
        :scrollable="true">

        <template>
          <Timeline>
              <TimelineItem :color="item.content.indexOf('新增') !== -1 ? 'green' : 'red'" v-for="(item, index) in logs" :key="index">
                <p class="time">{{ item.created_at}}</p>
                <p class="content">{{ item.content}}</p>
                <p class="content">{{ item.remark}}</p>
              </TimelineItem>
          </Timeline>
        </template>
    </Modal>

  </div>
</template>

<script>
import moment from 'moment'
import { getSoftwareAssetsDistribute, addSoftwareAssetsDistribute, updateSoftwareAssetsDistribute, deleteSoftwareAssetsDistribute,
  addSoftwareAssetsLog, getSoftwareAssetsLog, getPeopleLst, getSoftwareAssetsAuthorize, getWxOrg } from '@/api/cmdb'
import { Treeselect, LOAD_CHILDREN_OPTIONS, ASYNC_SEARCH } from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
export default {
  name: 'softwareDistribute',
  components: { Treeselect },
  data () {
    return {
      formItem: {
        software_assets_authorize: [],
        update_user: this.$store.state.user.userId,
        department: null,
        count: null,
        director_name: null,
        director_mail: null,
        director_userid: null
      },
      formItemSource: {},
      logs: [],
      ruleValidate: {
        department: [
          { required: true, message: '部门名称不能为空', trigger: 'blur' }
        ],
        director_name: [
          { required: true, message: '责任人不能为空', trigger: 'blur' }
        ]
      },
      distributeColumns: [

        {
          width: 60,
          align: 'center',
          key: 'id',
          ellipsis: true,
          tooltip: true
        },

        {
          title: '授权软件',
          key: 'software_assets_authorize_info',
          ellipsis: true,
          tooltip: true,
          minWidth: 200,
          align: 'center',
          render: (h, params) => {
            return h('span', { }, [
              params.row.software_assets_authorize_info.map((item, _) => {
                return h('Tag', {
                  props: {
                    type: 'border',
                    color: '#7232dd'
                  },
                  style: {
                    marginLeft: '5px',
                    display: item.name ? 'inline-block' : 'none'
                  }
                }, item.name)
              })
            ]
            )
          }
        },

        {
          title: '部门',
          key: 'department',
          ellipsis: true,
          tooltip: true,
          align: 'center',
          minWidth: 400,
          render: (h, params) => {
            return h('a', {
              props: {
                type: 'warning',
                size: 'small'
              },
              on: {
                click: () => {
                  this.logModal = true
                  getSoftwareAssetsLog({ software_assets_authorize_distribute_id: params.row.id, page: 1, size: 1000 }).then(rsp => {
                    const { results } = rsp.data
                    this.logs = results
                  })
                }
              }
            }, params.row.department)
          }
        },

        {
          title: '数量',
          key: 'count',
          ellipsis: true,
          tooltip: true,
          align: 'center',
          minWidth: 80
        },

        {
          title: '责任人姓名',
          key: 'director_name',
          ellipsis: true,
          tooltip: true,
          align: 'center',
          minWidth: 120
        },
        {
          title: '责任人邮箱',
          key: 'director_mail',
          ellipsis: true,
          tooltip: true,
          align: 'center',
          minWidth: 150
        },

        {
          title: '维护人',
          key: 'update_user_info',
          ellipsis: true,
          tooltip: true,
          minWidth: 120,
          align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Tag', {
              }, params.row.update_user_info.name)
            ])
          }
        },

        {
          title: '创建时间',
          key: 'created_at',
          align: 'center',
          tooltip: true,
          minWidth: 150,
          render: (h, params) => {
            if (params.row.created_at) {
              return h('span', moment(params.row.created_at).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },

        {
          title: '修改时间',
          key: 'updated_at',
          align: 'center',
          tooltip: true,
          minWidth: 150,
          render: (h, params) => {
            if (params.row.updated_at) {
              return h('span', moment(params.row.updated_at).format('YYYY-MM-DD HH:mm:ss'))
            } else {
              return ''
            }
          }
        },

        {
          title: '备注',
          key: 'remark',
          align: 'center',
          ellipsis: true,
          tooltip: true,
          minWidth: 150
        },

        {
          title: '操作',
          align: 'center',
          fixed: 'right',
          width: 150,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                on: {
                  click: () => {
                    this.formItem = { ...params.row }
                    this.formItemSource = { ...params.row }
                    this.formItem.director_name = { id: this.formItem.director_name, label: this.formItem.director_name }
                    this.drawerChange = true
                  }
                }
              }, '编辑'),
              h('Poptip', {
                props: {
                  confirm: true,
                  transfer: true,
                  placement: 'bottom',
                  title: '你确定要删除吗?'
                },
                style: {
                  display: this.$store.state.user.superuser ? 'inline-block' : 'none'
                },
                on: {
                  'on-ok': () => {
                    deleteSoftwareAssetsDistribute({ id: params.row.id }).then(_ => {
                      this.getSoftwareAssetsDistribute()
                    })
                  }
                }
              }, [
                h('Button', {
                  props: {
                    type: 'error',
                    size: 'small'
                  }
                }, '删除')
              ])
            ])
          }
        }

      ],
      params: { page: 1, size: 10 },
      assetList: [],
      software_assets_authorize: [],
      count: 0,
      drawerChange: false,
      changeLoadingShow: false,
      logModal: false,
      director_name: false,
      options: []
    }
  },
  mounted () {
    this.getSoftwareAssetsDistribute()
    this.getWxOrg(0)
  },
  methods: {

    add () {
      this.drawerChange = true
      this.formItem = {
        software_assets_authorize: [],
        update_user: this.$store.state.user.userId,
        department: null,
        count: null,
        director_name: null,
        director_mail: null,
        director_userid: null
      }
    },

    getSoftwareAssetsDistribute () {
      getSoftwareAssetsDistribute(this.params).then(rsp => {
        const { results, count } = rsp.data
        this.assetList = results
        this.count = count
      })
      getSoftwareAssetsAuthorize({ page: 1, size: 10000 }).then(rsp => {
        const { results } = rsp.data
        this.software_assets_authorize = []
        results.forEach(_r => {
          this.software_assets_authorize.push({ key: _r.id, label: _r.name, disabled: false })
        })
        console.log(this.software_assets_authorize)
      })
    },

    currentHandle (page) {
      this.params.page = page
      this.getSoftwareAssetsDistribute()
    },

    pageSizeHandle (size) {
      this.params.size = size
      this.getSoftwareAssetsDistribute()
    },

    getWxOrg (id) {
      let params = {
        parentid: id
      }
      getWxOrg(params).then(res => {
        this.options = res.data.result
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取公司组织列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取公司组织列表失败！服务器无响应'
          })
        }
      })
    },

    loadOptions ({ action, parentNode, callback, instanceId }) {
      console.log(parentNode)
      if (action === LOAD_CHILDREN_OPTIONS) {
        let params = {
          parentid: parentNode.id,
          get_people: 1,
          department: 1
        }
        getWxOrg(params).then(res => {
          let data = res.data.result
          data.forEach(_d => {
            if (parentNode.parents) {
              _d.parents = `${parentNode.parents}/${parentNode.label}`
            } else {
              _d.parents = parentNode.label
            }
          })
          parentNode.children = data
          callback()
        }).catch(res => {
          if (res.request) {
            this.$Notice.error({
              title: '获取公司组织列表失败！请求状态码:' + res.request.status,
              desc: res.request.responseText
            })
          } else {
            this.$Notice.error({
              title: '获取公司组织列表失败！服务器无响应'
            })
          }
        })
      }
    },

    loadOptionsAsync ({ action, searchQuery, callback }) {
      if (action === ASYNC_SEARCH) {
        // 异步搜索人员模式
        if (searchQuery) {
          let params = {
            parentid: 1,
            searchQuery: searchQuery,
            get_people: 1
          }
          getPeopleLst(params).then(res => {
            if (res.data.result) {
              callback(null, res.data.result)
            }
          }).catch(res => {
            if (res.request) {
              this.$Notice.error({
                title: '获取公司组织列表失败！请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            } else {
              this.$Notice.error({
                title: '获取公司组织列表失败！服务器无响应'
              })
            }
          })
        }
      }
    },

    eventInputDeparement (value) {
      value.label = `${value.parents}/${value.label}`
    },

    eventInputUser (value) {
      // this.director_name = value.label
      this.formItem.director_mail = value.email
      this.formItem.director_userid = value.id
    },

    filterMethod (data, query) {
      return data.label.indexOf(query) > -1
    },

    handleChangeAuthorize (newTargetKeys, direction, moveKeys) {
      this.formItem.software_assets_authorize = newTargetKeys
    },

    handleSubmit (name) {
      let that = this.formItem
      if (typeof (that.director_name) !== 'string') {
        that.director_name = that.director_name.label
      }
      console.log(that)
      if (typeof (that.director_name) !== 'string') {
        that.director_name = that.director_name && 'label' in that.director_name ? that.director_name.label : ''
      }
      if (typeof (that.department) !== 'string') {
        that.department = that.department && 'label' in that.department ? that.department.label : ''
      }
      let remark = {}
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (that.software_assets_authorize.length === 0) {
            this.$Notice.error({ title: '授权软件不能为空' })
            return
          }
          Object.keys(this.formItem).forEach(_key => {
            if (this.formItem[_key] !== this.formItemSource[_key]) {
              remark[_key] = `${this.formItemSource[_key]} -> ${this.formItem[_key]}`
            }
          })
          this.changeLoadingShow = true
          if (that.id) {
            if (Object.keys(remark).length !== 0) {
              updateSoftwareAssetsDistribute(that).then(rsp => {
                const { data } = rsp
                this.getSoftwareAssetsDistribute()
                addSoftwareAssetsLog({ log_type: '授权软件分配', content: '修改', operator_id: this.$store.state.user.userId, software_assets_authorize_distribute: data.id, remark: JSON.stringify(remark) })
                this.changeLoadingShow = false
                this.drawerChange = false
                this.$Notice.success({ title: '修改成功' })
              }).catch(_ => {
                this.changeLoadingShow = false
                this.drawerChange = false
                this.$Notice.error({ title: '异常!' })
              })
            } else {
              this.changeLoadingShow = false
              this.$Notice.error({ title: '无数据变化！' })
            }
          } else {
            addSoftwareAssetsDistribute(that).then(rsp => {
              const { data } = rsp
              this.getSoftwareAssetsDistribute()
              addSoftwareAssetsLog({ log_type: '授权软件分配', content: '新增', operator_id: this.$store.state.user.userId, software_assets_authorize_distribute: data.id, remark: JSON.stringify(this.formItem) })
              this.changeLoadingShow = false
              this.drawerChange = false
              this.$Notice.success({ title: '添加成功' })
            }).catch(_ => {
              this.changeLoadingShow = false
              this.drawerChange = false
              this.$Notice.error({ title: '异常!' })
            })
          }
        } else {
          this.changeLoadingShow = false
          this.$Notice.error({ title: '请检查输入框！' })
        }
      })
    }

  }
}
</script>

<style>
  .ivu-poptip-body {
    text-align: left !important;
  }
</style>
